import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import MasterTable from "../../../views/dashboard/widget/MasterTabel";
import AddLibraryForm from "./library-forms/add-library-form";
import { getLibraryPanelties } from "./libraryServices/libraryManagement";
import { useGlobalState } from "../../../services/hostelConst";


const LibraryPenalty = () => {
  const { toggleHostelMenu } = useGlobalState();
  var { id } = useParams();
  const {
    _advanceFilterList,
    updateAdvanceFilterList,
    resetAdvanceFilterData,
    modalState,
    openModal,
  } = useGlobalState();

  useEffect(() => {
    openModal({ ...modalState, libraryId: id });
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
      };
    });

    toggleHostelMenu(false);

    return () => {};
  }, []);

  return (
    <MasterTable
      getTableData={getLibraryPanelties}
      tab1={"Library"}
      tab2={"Library Penalty"}
      libraryId={id}
      AddForm={AddLibraryForm}
      actions={{
        // status: true,
        edit: true,
        delete: true,
      }}
    />
  );
};

export default LibraryPenalty;

